import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonHeader, IonFooter } from '@ionic/react';
import ReactDOM from 'react-dom';


import { ShowProductPicsModal } from './Modal_ShowProductPics';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';
import { OrderDetailsModal } from './OrderDetailsModal';

import '../../../../css/qavaApp.css';


export function ViewOrderListModal_InStore (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [productPicsModal, setProductPicsModal] = useState(false);
    let [checkInModal, setCheckInModal] = useState(false);
    
    let [checkInModal_tracker, setCheckInModal_tracker] = useState(null);
    
    let [viewInventoryAvailableProducts, setViewInventoryAvailableProducts] = useState([]);
    
    let [orderID, setOrderID] = useState(null);
    let [orderTotal, setOrderTotal] = useState(null);
    let [invoiceForm, setInvoiceForm] = useState(null);
    let [showInvoiceModal, setViewInvoiceModal] = useState(null);
    let [productPic3, setProductPic3] = useState(null);
    let [productPic4, setProductPic4] = useState(null);
    
    let [showOrderDetailsModal, setShowOrderDetailsModal] = useState(false);

    useEffect(() => {
        if (props.openModal == true) {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    Tracker: '74101_view_active_Orders_inStore',
                    user: acctID,
                    xStartDateRange: authenticatedMerchent_context.startDate,
                    xEndDateRange: authenticatedMerchent_context.endDate,
                    sessionID: sessionID,
                }),
            };
    
            fetch(baseURL + 'retail_merchantAcct_argsjqApp', requestOptions)
                .then(res => res.text())
                .then(res => {
                    let rows = res.toString().split('~~~');
    
                    for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                        let cols = rows[rownum].split('|');
    

                        setViewInventoryAvailableProducts((prevAvailableProducts) => {
                            return prevAvailableProducts.concat({
                                order_id: cols[0],
                                cart_id: cols[1],
                                order_phone_number: cols[2],
                                client_first_name: cols[3],
                                client_last_name: cols[4],
                                client_phone_number: cols[5],
                                client_email_address: cols[6],
                                client_payment_type: cols[7],
                                client_member_number: cols[8],
                                client_mm_provider: cols[9],
                                client_mm_number: cols[10],
                                order_total: parseFloat(cols[11]).toFixed(2),
                                order_amt_paid: parseFloat(cols[12]).toFixed(2),
                                order_start_date_reserved: cols[13],
                                order_end_date_reserved: cols[14],
                                order_start_date: cols[15].slice(0,10),
                                order_end_date: cols[16],
                                merchant_invoice_id: cols[17],
                                invoiceForm: cols[18],
                                customer_invoice_id: cols[19],
                                invoiceTotal: parseFloat(cols[20]).toFixed(2),
                                transactionID: cols[21],
                                totalInvoiceAmount: cols[22],
                                transactionStatus: cols[23],
                                momo_provider: cols[24],
                                momo_financial_transaction_id: cols[25],
                                momo_external_id: cols[26],
                                momo_amount: cols[27],
                                momo_party_id: cols[28],
                                momo_payer_message: cols[29],
                                momo_payee_note: cols[30],
                                momo_pay_status: cols[31],
                                payment_type: cols[32],
                                verify_id_type: cols[33],
                                verify_id_number: cols[34],
                                ship_to_address: cols[35],
                                latitude: cols[36],
                                longitude: cols[37],
                                status: cols[38],


                            });
                        });
                    }
                });
        }
    }, [props.openModal]);
    
    function closeModalHandler(event) {
        setViewInventoryAvailableProducts([]);
        props.closeModal(event);
    }

    function viewInvoiceModalHandler(event) {

        //alert(event);

        setOrderID(event[1]);
        setOrderTotal(event[2]);
        setInvoiceForm(event[3]);
        setViewInvoiceModal(event[0]);

    }

    function handleOrderDetails(event)
    {

        setOrderID(event[0]);
        setOrderTotal(event[1])
        setShowOrderDetailsModal(true);
    }
    
    return (
        <React.Fragment>
            {props.openModal == true ? (
                <IonModal isOpen={props.openModal}>
                    <IonHeader style={{color: "black"}}>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='12'>
                                    <h3> IN-STORE ORDERS </h3>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>
    
                    <IonGrid className='appGridContent'>
                        <IonRow>
                            <IonCol size='3'>
                                <h3> Date </h3>
                            </IonCol>
                            <IonCol size='2'>
                                <h3> Name </h3>
                            </IonCol>
                            <IonCol size='4'>
                                <h3> Total </h3>
                            </IonCol>
                            <IonCol size='3'>
                                <h3> Action </h3>
                            </IonCol>
                        </IonRow>
                        {viewInventoryAvailableProducts.map((detailData) => {
                            return (
                                <IonRow key={detailData.order_id}>
                                    <IonCol size='3'>{detailData.order_start_date}</IonCol>
                                    <IonCol size='2'>{detailData.client_first_name+" "+detailData.client_last_name}</IonCol>
                                    <IonCol size='4'>{detailData.invoiceTotal}</IonCol>
                                    <IonCol size='3'>
                                        {/*<IonButton class='gridResultColumnButton' onClick={() => viewInvoiceModalHandler([true, detailData.order_id, detailData.invoiceTotal, detailData.invoiceForm])}> View </IonButton>*/}
                                        <IonButton onClick={() => handleOrderDetails([detailData.order_id, detailData.invoiceTotal])}>Details</IonButton>
                                    </IonCol>
                                </IonRow>
                            );
                        })}
                        <IonRow>
                            <IonCol>
                                <IonButton> ADD ORDER</IonButton>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
    
                    {showInvoiceModal == true && <ViewInvoiceModal openModal={ showInvoiceModal } closeModal={() => setViewInvoiceModal(false)} data={{
                                        fileLocation: `/api/form/${invoiceForm}/${schema}`, 
                                        }}></ViewInvoiceModal>}
    

                    {showOrderDetailsModal == true && <OrderDetailsModal openModal={ showOrderDetailsModal } closeModal={() => setShowOrderDetailsModal(false)} data={{
                        orderID: orderID, 
                        orderTotal: orderTotal,
                                            }}></OrderDetailsModal>}
    
    
                    <IonFooter className='grid_footer'>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonButton onClick={closeModalHandler}> Close </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonFooter>
                </IonModal>
            ) : null}
        </React.Fragment>

    )
}